import { Component } from '@theme/component';
import { ProductSelectEvent, StandardEvents } from '@shopify/events';

/** Keeps one dimensions Image block synchronized with the selected variant. */
class ProductDimensionsImageComponent extends Component {
  /** @type {AbortController | undefined} */
  #controller;

  connectedCallback() {
    super.connectedCallback();

    this.#controller?.abort();
    this.#controller = new AbortController();

    this.closest('.shopify-section, dialog')?.addEventListener(
      StandardEvents.productSelect,
      this.#handleProductSelect,
      { signal: this.#controller.signal }
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
    this.#controller = undefined;
  }

  /** @param {ProductSelectEvent} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    const sourcePicker = event.target.closest('variant-picker');
    if (sourcePicker?.dataset.productId !== this.dataset.productId) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        if (detail.newProduct) {
          this.dataset.productId = detail.newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const blockId = this.dataset.blockId;
        if (!blockId) return;

        const replacement = detail.html.querySelector(
          `product-dimensions-image-component[data-block-id="${CSS.escape(blockId)}"]`
        );

        if (replacement) this.replaceWith(replacement);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          console.warn('[product-dimensions-image] Variant update failed:', error);
        }
      });
  };
}

if (!customElements.get('product-dimensions-image-component')) {
  customElements.define('product-dimensions-image-component', ProductDimensionsImageComponent);
}
